import { render, staticRenderFns } from "./NoSelect.vue?vue&type=template&id=72ac23cf&"
import script from "./NoSelect.vue?vue&type=script&lang=js&"
export * from "./NoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports